var jwjURL = {
  baseURL: 'https://xnh.incich.com/',
  imgURL: 'https://xnh.incich.com/display-web/UploadImageServlet',
}

export default jwjURL